import styled from "react-emotion";

const ChoiceTitle = styled("h3")`
  color: #fff;
  font-size: 1.25rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  margin: 0;
`;

export default ChoiceTitle;
